import React from 'react';
import {makeStyles} from "@mui/styles";
import {Box, FormControlLabel, Radio} from '@mui/material';

const useStyles = makeStyles(() => ({
    root: {
        padding: 18,
        background: "#fff",
        borderRadius: 10,
        margin: "16px 0"
    },
    title: {
        fontSize: 12,
    }
}));

interface Props {
    readonly title: string,
    readonly value: string
    readonly description: string
}

function IntegrationAuthTypeItem({title, value,description}: Props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Box sx={{display: "flex", alignItems: "center"}} className={classes.title}>
                <FormControlLabel value={value} control={<Radio />} label={title} />
            </Box>
            <div>
                <p>{description}</p>
            </div>
        </div>
    );
}

export default IntegrationAuthTypeItem;